/**
 * Brand date picker for the private-events form's date field.
 *
 * Uses the vendored flatpickr (assets/flatpickr.min.*) so the calendar popup is
 * fully styled (assets/datepicker.css) and easier to use than the native date
 * control. The field stays a normal text input that submits a readable date
 * string (e.g. "June 15, 2026"); disableMobile keeps the same styled calendar
 * on phones instead of falling back to the OS picker.
 */
(function () {
  if (typeof window.flatpickr !== 'function') return;
  window.flatpickr('.private-events-form__input--date', {
    dateFormat: 'F j, Y',
    minDate: 'today',
    disableMobile: true
  });
})();
